import { StepForm, StepHeader } from '@types'
import { ReactNode } from 'react'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import Step6 from './Step6'

const steps = {
  1: Step1,
  2: Step2,
  3: Step3,
  4: Step4,
  5: Step5,
  6: Step6,
}

export const stepsComponents: Record<
  number,
  ({ headerData, formData }: { headerData: StepHeader & Record<string, StepHeader>, formData: StepForm }) =>
  Record<'header' | 'form' | 'nextButton', ReactNode>
> = Object.fromEntries(
  Object.entries(steps).map(([key, Step]) => [
    Number(key),
    ({ headerData, formData }) => ({
      header: <Step.Header data={headerData} />,
      form: <Step.Form data={formData} />,
      nextButton: <Step.Form.Button data={formData} />,
    }),
  ])
)
